import { Spinner } from '~/components/Spinner';

function LoadingScreen() {
  return (
    <div
      className="flex h-screen flex-1 items-center justify-center"
      role="status"
    >
      <Spinner />
    </div>
  );
}

LoadingScreen.displayName = 'LoadingScreen';

export { LoadingScreen };
